<template>
    <div :class="mainClass">
        <aside class="left-panel">
            <div class="left-panel__content">
                <div class="left-panel__header">
                    <span>{{ leftTitle }}</span>
                    <el-upload ref="upload" style="margin-left: auto" :action="uploadUrl" :accept="accept"
                        :before-upload="beforeUpload" :show-file-list="false" multiple :limit="10" :data="uploadParams"
                        :on-success="handleUploadSuccess">
                        <el-button size="small" type="primary" plain>导入</el-button>
                    </el-upload>
                    <!-- <el-upload
                        ref="upload"
                        style="margin-left: auto"
                        action="#"
                        :http-request="handleUpload2"
                        multiple
                        :limit="10"
                    >
                        <el-button size="small" type="primary" plain>导入视频</el-button>
                    </el-upload> -->
                </div>
                <div class="left-panel__content-body">
                    <el-scrollbar style="height: 100%; overflow: hidden" ref="sourceListRef">
                        <template v-for="(item, index) in sourceList">
                            <SourceItem :isActive="index === currentSelectedSourceIndex" :data="item"
                                @click="handleSourceClick(item, index)" @delete="handleDeleteAsset(item)" :key="index"
                                style="margin-bottom: 16px" :id="`sourceItem${index}`" :ref="`sourceItem${index}`">
                            </SourceItem>
                        </template>
                    </el-scrollbar>
                </div>
            </div>
        </aside>
        <aside class="right-panel">
            <div class="right-panel__content">
                <div class="right-panel__header">
                    <span>事件信息</span>
                    <el-button style="margin-left: auto" size="small" type="primary" plain
                        @click="addCategory">添加事件</el-button>
                </div>
                <div class="right-panel__content-body">
                    <div class="form-mask" v-if="current.category === -1" title="请添加事件或选择一个事件然后填写"></div>
                    <template v-if="!eventCanEdit">
                        <FormDetail :data="categoryFormData" :rules="formRules" :areaList="areaList"
                            :jurisdictionList='jurisdictionList'></FormDetail>
                    </template>
                    <template v-else>
                        <el-form ref="cForm" :model="categoryFormData" :rules="formRules" :disabled="editStatus">
                            <el-form-item label="事件名称" prop="name">
                                <el-input size="small" v-model="categoryFormData.name" :maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="事件分类" prop="eventTypeId">
                                <el-cascader :props="{ value: 'id', label: 'name' }" style="width: 100%"
                                    v-model="categoryFormData.eventTypeId" filterable clearable
                                    :options="eventOptions"></el-cascader>
                            </el-form-item>
                            <!-- <el-form-item label="发现时间" prop="happenTime">
                                <el-date-picker
                                    style="width: 100%"
                                    type="datetime"
                                    v-model="categoryFormData.happenTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    size="small"
                                    placeholder="选择日期"
                                    popper-class="c-date-popper"
                                >
                                </el-date-picker>
                            </el-form-item> -->
                            <el-form-item label="经纬度" prop="longitude">
                                <!-- <el-input
                                size="small"
                                v-model="lngLat"
                                placeholder="经度,纬度"
                                @input="handleInput($event, 'lngLat')"
                            ></el-input> -->
                                <LngLatInput size="small" :longitude.sync="categoryFormData.longitude"
                                    :latitude.sync="categoryFormData.latitude" @change="handleLngLatChange">
                                    <el-button slot="append" size="small" type="primary"
                                        @click="showAmapVisible()">拾取</el-button>
                                </LngLatInput>

                                <CAmap :visible.sync="amapVisible"
                                    :markerPosition="[categoryFormData.longitude, categoryFormData.latitude]"
                                    :categoryFormData="categoryFormData" type="add" @ok="handlePickPositionOk"
                                    coordType="wgs84"></CAmap>
                            </el-form-item>
                            <el-form-item label="所属区域" prop="area">
                                <el-cascader style="width: 256px" v-model="categoryFormData.areaId"
                                    placeholder="请选择搜索区域" :options="areaList" @change="changeArea"
                                    filterable></el-cascader>
                            </el-form-item>
                            <!-- prop="jurisdictionId" -->
                            <!-- <el-form-item label="所属辖区" >
                                <el-select style="width:256px;" v-model="categoryFormData.jurisdictionId" placeholder="请选择所属辖区">
                                    <el-option
                                        v-for="item in jurisdictionList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item> -->

                            <el-form-item label="地址">
                                <el-input size="small" v-model="categoryFormData.address" :maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="发现人" prop="happenBy">
                                <el-input size="small" v-model="categoryFormData.happenBy" :maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" prop="phone">
                                <el-input size="small" v-model="categoryFormData.phone" :maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="采集设备" prop="collectDevice">
                                <!-- :disabled="true" -->
                                <el-input size="small" v-model="categoryFormData.collectDevice"
                                    :maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="事件描述" prop="remark">
                                <el-input size="small" type="textarea" :maxlength="100" resize="none"
                                    :autosize="{ minRows: 2, maxRows: 6 }" v-model="categoryFormData.remark"
                                    show-word-limit></el-input>
                            </el-form-item>
                        </el-form>
                        <el-button size="small" @click="resetFormData">重置</el-button>
                        <el-button :disabled="disabled" size="small" type="primary" @click="save">保存事件</el-button>
                    </template>
                </div>
            </div>
        </aside>

        <div class="annotator-wrap-middle">
            <header class="toolbar-wrap toolbar-wrap__horizontal">
                <!--  -->
                <div class="annotator-Tool">
                    <SelectTool ref="selectTool" v-model="activeTool" :scale="image.scale" @setcursor="setCursor"
                        :enable="eventCanEdit && tooTStatus" />
                    <BBoxTool v-model="activeTool" :scale="image.scale" @setcursor="setCursor" ref="bbox"
                        :enable="eventCanEdit && tooTStatus" />
                    <PolygonTool v-model="activeTool" :scale="image.scale" @setcursor="setCursor" ref="polygon"
                        :enable="eventCanEdit && tooTStatus" />
                    <CenterButton />
                    <ZoomInButton />
                    <ZoomOutButton />
                </div>
                <div class="annotator-model">
                    <div class="model-1" :class="modelType === 1 ? 'model-activity' : ''" @click="bindModelType(1)">
                        标准模式
                    </div>
                    <!-- <div
                        class="model-1"
                        :class="modelType === 2 ? 'model-activity' : ''"
                        @click="bindModelType(2)"
                    >
                        对比模式
                    </div>
                    <div
                        class="model-1"
                        :class="modelType === 3 ? 'model-activity' : ''"
                        @click="bindModelType(3)"
                    >
                        地图模式
                    </div> -->
                </div>
            </header>
            <div class="annotator-middle-panel">
                <div id="frame" class="annotator-frame" ref="annotatorFrame" @wheel="onwheel" :style="{
                    cursor: cursor,
                    width: modelType === 1 ? '100%' : '50%',
                }">
                    <!-- vue元素无任何改变时，不会重新加载，使用:key+变量，可刷新元素 -->
                    <canvas class="annotator-canvas" :key="'canva_' + modelType" ref="canvasEditor" resize />
                </div>
                <div class="annotator-model-main" v-if="modelType !== 1 && !isVideo">
                    <!-- 对比模式 -->
                    <div v-if="modelType === 2" class="annotator-model-contrast">
                        <el-carousel :autoplay="false" class="annotator-img-main" ref="historyCarousel"
                            indicator-position="none" @change="historyChange">
                            <el-carousel-item class="annotator-carousel" v-for="(item, index) in historyList"
                                :key="index">
                                <img ref="historyBox" class="annotator-img" :src="item.filePath" alt="" :style="{
                                    top: historyTop + 'px',
                                    left: historyLeft + 'px',
                                    transform: historyScale,
                                    width: image.raster.width / image.scale + 'px',
                                    height: image.raster.height / image.scale + 'px',
                                }" />
                            </el-carousel-item>
                        </el-carousel>
                        <div class="history-main" :style="historyShow ? 'height: 60vh;' : '40px'">
                            <div class="history-title">
                                <i class="history-i el-icon-picture" @click="historyShow = !historyShow"></i>
                                <div class="history-txt" @click="historyShow = !historyShow">
                                    {{ historyVal }}
                                </div>
                                <i class="history-i el-icon-close" style="display: inline-block"
                                    @click="historyShow = false"></i>
                            </div>
                            <div v-show="historyShow" class="history-list">
                                <el-scrollbar style="height: 100%">
                                    <template v-for="item in historyPictureList">
                                        <template v-if="item.eventList">
                                            <historyItem v-for="cell in item.eventList" :key="cell.code"
                                                :historyItem="cell" :activityHistory="activityImg"
                                                @bindHistoryImg="bindHistoryImg" @associatedEvents="associatedEvents"
                                                :type="'event'"></historyItem>
                                        </template>
                                        <template v-else>
                                            <historyItem :key="item.id" :historyItem="item"
                                                :activityHistory="activityImg" @bindHistoryImg="bindHistoryImg">
                                            </historyItem>
                                        </template>
                                    </template>
                                </el-scrollbar>
                            </div>
                        </div>
                    </div>
                    <!-- 地图模式 -->
                    <div v-if="modelType === 3" class="annotator-model-map">
                        <TypeAmap :key="'TypeAmap_' + categoryFormData.longitude + '_' + categoryFormData.latitude"
                            :markerPosition="[categoryFormData.longitude, categoryFormData.latitude]"
                            :markerList="markerList" :eventTypeId="categoryFormData.eventTypeId"
                            @associatedEvents="associatedEvents" coordType="wgs84">
                        </TypeAmap>
                    </div>
                </div>
            </div>
            <div class="video-bar" v-if="dataType === DataTypeEmu.VIDEO">
                <div class="video-bar__content">
                    <el-slider v-model="currentFrame" :max="endFrame" @change="handleChangeFrame"></el-slider>
                    <div style="padding-bottom: 10px">
                        <span class="border-right total-duration">{{ duration }}</span>
                        <span>&nbsp;帧数&nbsp;</span>
                        <el-input-number @change="handleChangeFrame" style="width: 100px" v-model="currentFrame"
                            :min="0" :max="endFrame" size="mini" controls-position="right"></el-input-number>
                        <span>&nbsp;/&nbsp;{{ endFrame }}</span>
                    </div>
                </div>
            </div>
            <div class="bottom-panel">
                <div class="bottom-panel__header">
                    <span class="bottom-panel__header-title" :class="{ 'bottom-tab-active': bottomTab === 'event' }"
                        @click="bottomTab = 'event'">事件列表</span>
                    <span v-if="isVideo" class="bottom-panel__header-title"
                        :class="{ 'bottom-tab-active': bottomTab === 'frame' }" @click="bottomTab = 'frame'">标注帧</span>
                </div>
                <div class="bottom-panel__content">
                    <!-- 事件列表tab -->
                    <div class="bottom-panel__content-main" v-show="bottomTab === 'event'">
                        <div class="button-prev-wrap">
                            <div class="swiper-button-prev"></div>
                        </div>
                        <swiper :options="swiperOptions" class="mySwiper swiper-1">
                            <swiper-slide v-for="(category, index) in categories" :key="index + '-category'">
                                <Category :showDelete="category.eventStatus == 1 ||
                                    category.eventStatus == '1' ||
                                    !category.eventStatus
                                    " @click="onCategoryClick(category, index)"
                                    @delete="onCategoryDeleteClick(category, index)"
                                    @download="onCategoryDownloadClick(category, index)" ref="category" :index="index"
                                    :category="category" :simplify="simplify" :active-tool="activeTool"
                                    :scale="image.scale" :current="current" :hover="hover" :opacity="1"></Category>
                            </swiper-slide>
                        </swiper>
                        <div class="button-next-wrap">
                            <div class="swiper-button-next"></div>
                        </div>
                    </div>
                    <!-- 帧标注tab -->
                    <div class="bottom-panel__content-main" v-if="isVideo" v-show="bottomTab === 'frame'">
                        <div class="button-prev-wrap">
                            <div class="swiper-button-prev swiper-button-prev2"></div>
                        </div>
                        <swiper :options="swiperOptions2" class="mySwiper swiper-1">
                            <swiper-slide v-for="(frameItem, index) in frameAnnotations" :key="index + '-frame'">
                                <FrameCard :showDelete="eventCanEdit" :checked="frameItem.id === currentFrame"
                                    :data="frameItem" :currentSource="currentSelectedSource"
                                    @click="handleFrameCardClick(frameItem, index)"
                                    @delete="handleFrameCardDeleteClick(frameItem, index)"></FrameCard>
                            </swiper-slide>
                        </swiper>
                        <div class="button-next-wrap">
                            <div class="swiper-button-next swiper-button-next1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import paper from 'paper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import g from '@global';
import AMapLoader from '@amap/amap-jsapi-loader';
import SelectTool from './components/annotator/tools/SelectTool.vue';
import BBoxTool from './components/annotator/tools/BBoxTool.vue';
import PolygonTool from './components/annotator/tools/PolygonTool.vue';
import CenterButton from './components/annotator/tools/CenterButton.vue';
import ZoomInButton from './components/annotator/tools/ZoomInButton.vue';
import ZoomOutButton from './components/annotator/tools/ZoomOutButton.vue';
// import UndoButton from './components/annotator/tools/UndoButton.vue';
import LngLatInput from './components/LngLatInput/LngLatInput.vue';
import SourceItem from './components/SourceItem/SourceItem.vue';
import FrameCard from './components/FrameCard/FrameCard.vue';
import CAmap from './components/CAmap/CAmap.vue';
import TypeAmap from './components/CAmap/TypeAmap.vue';

// import DownloadImageButton from './components/annotator/tools/DownloadImageButton.vue';
import Category from './components/annotator/Category.vue';
import FormDetail from './components/annotator/FormDetail/FormDetail.vue';
import 'swiper/css/swiper.css';
import './styles/tooltip.css';
import * as Api from './Api';
import * as ValidatUtil from './util/validator.js';
import ExifUtil from './util/EXIFUtil';
import * as FileUtil from './util/FileUtil';
import { formatDuration } from './util';
import historyItem from './components/historyItem/historyItem.vue';
import { getAreaInfo } from '../../../modules/common/Util/src/amapUtils';


// eslint-disable-next-line no-unused-vars
import MapTransformTool from './util/transform.js';

paper.install(window);

const uploadUrl = `${g.getBaseServer()}/event/mark/upload`;
const DataTypeEmu = {
    VIDEO: 1,
    IMAGE: 2,
};
export default {
    components: {
        SelectTool,
        BBoxTool,
        PolygonTool,
        CenterButton,
        ZoomInButton,
        ZoomOutButton,
        // UndoButton,
        Category,
        // DownloadImageButton,
        Swiper,
        SwiperSlide,
        LngLatInput,
        SourceItem,
        FrameCard,
        CAmap,
        TypeAmap,
        FormDetail,
        historyItem,
    },
    props: {},
    data() {
        const lngLatValidator = (rule, value, callback) => {
            let lng = this.categoryFormData.longitude;
            let lat = this.categoryFormData.latitude;

            if (lng || lat) {
                if (ValidatUtil.checkLongitude(lng) && ValidatUtil.checkLatitude(lat)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的经纬度坐标!'));
                }
            } else {
                callback(new Error('必填项不能为空!'));
            }
        };
        // 验证电话号码
        const phoneValidator = (rule, value, callback) => {
            if (value) {
                if (ValidatUtil.checkMobile(value) || ValidatUtil.checkTelPhone(value)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的电话号码!'));
                }
            } else {
                callback();
            }
        };
        return {
            disabled: false,
            modelType: 1,
            historyId: '',
            eventStatus: false,
            editStatus: true,
            tooTStatus: false,
            activityImg: '',
            activityEventImg: '',
            historyVal: '',
            markerList: [],
            historyList: [], // 历史事件
            historyPictureList: [], // 历史图片
            historyShow: false,
            historyDeg: 0,
            historyTop: 0,
            historyLeft: 0,
            historyScale: 'scale(1)',
            historySize: 0,
            mousewheelevt: null,

            modelHeight: 100,
            uploadUrl,
            markId: '', // 标注任务Id
            dataType: 2,
            areaList: [], // 所属区域列表
            jurisdictionList: [], // 所属辖区列表
            address: null,
            swiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                mousewheel: true,
            },
            swiperOptions2: {
                // slidesPerView: 8,
                // spaceBetween: 16,
                slidesPerView: 'auto',
                spaceBetween: 8,
                navigation: {
                    nextEl: '.swiper-button-next2',
                    prevEl: '.swiper-button-prev2',
                },
                mousewheel: true,
            },
            // accept: 'image/*,video/*',
            sourceList: [],
            activeTool: 'Polygon',
            cursor: 'move',
            paper: null,
            simplify: 1,
            zoom: 0.2,
            image: {
                raster: {},
                scale: 0,
                ratio: 0,
                data: null,
                url: '',
                imageUrl: '',
                filename: '',
                id: '',
                dataId: '',
                metadata: {
                    longitude: '',
                    latitude: '',
                },
            },

            text: {
                topLeft: null,
                topRight: null,
            },
            pinching: {
                old_zoom: 1,
            },
            currentSelectedSourceIndex: 0,
            sourceId: '',
            currentSelectedSource: {}, // 当前选择的资源
            current: {
                category: -1,
                // annotation: -1,
                annotation: -1,
                keypoint: -1,
            },
            currentFrame: 0, // 当前帧
            endFrame: 0, // 总帧数
            hover: {
                category: -1,
                annotation: -1,
                keypoint: -1,
            },
            categoryFormData: {},
            lngLat: '', // 经纬度显示值
            categories: [], // 事件列表
            eventOptions: [], // 事件分类
            formRules: {
                name: [{ required: true, message: '必填项不能为空!', trigger: 'blur' }],
                eventTypeId: [{ required: true, message: '必填项不能为空!', trigger: 'change' }],
                // happenTime: [{ required: true, message: '必填项不能为空!', trigger: 'change' }],
                longitude: [{ required: true, validator: lngLatValidator, trigger: 'blur' }],
                phone: [{ validator: phoneValidator, trigger: 'blur' }],
                area: [{ required: true, message: '所属社区不能为空!', trigger: 'blur' }],
                // jurisdictionId: [{ required: true, message: '所属辖区不能为空!', trigger: 'blur' }],
                collectDevice: [{ required: true, message: '采集设备不能为空!', trigger: 'blur' }],
            },
            DataTypeEmu,
            bottomTab: 'event',
            amapVisible: false,
            userInfo: {}, // 当前登录用户信息
            captureVideoFrameIng: false, // 截图中
            // imgObj: {
            //     focallength: 0, // 焦距
            //     PixelXDimension: 0, // 图片宽
            //     PixelYDimension: 0, // 图片高
            //     longitude: 0, // 经度
            //     latitude: 0, // 纬度
            //     altitude: 0, // 图片高度
            // }, // 图片信息
        };
    },
    watch: {
        modelType: {
            handler(newVal) {
                if (newVal === 2) {
                    this.gethistoryPictureAndEventList(this.sourceId);
                }
                if (newVal === 3) {
                    this.getfindHistoryEventByGrid(this.sourceId);
                }
            },
            // immediate: true,
            deep: true,
        },
        currentSelectedSourceIndex: {
            handler(newVal) { },
            deep: true,
        },

        historyPictureList: {
            handler(newVal) {
                this.activityEventImg = 0;
            },
            deep: true,
        },
        categoryFormData: {
            handler(newVal, oldVal) {
                // console.log('categoryFormData', newVal);
                if (newVal.address) {
                    let area = this.categoryFormData.area;
                    if (Array.isArray(area)) {
                        if (area.length > 0) {
                            area[0].name = newVal.address;
                        }
                    } else if (typeof area === 'object') {
                        area.name = newVal.address;
                    }
                }
                if (!newVal.id && newVal.longitude && newVal.latitude) {
                    this.getAreaByLongitudeAndLatitude(newVal.longitude, newVal.latitude);
                    this.getEventJurisdiction(newVal.longitude, newVal.latitude);
                }

                if (newVal.name && newVal.eventTypeId && newVal.longitude && newVal.latitude) {
                    this.disabled = false;
                } else {
                    this.disabled = true;
                }
            },
            deep: true,
        },
        sourceList: {
            handler(val) {
                if (val && val.length > 0) {
                    this.sourceId = val[0].dataId;
                    this.handleSourceClick(
                        val[this.currentSelectedSourceIndex],
                        this.currentSelectedSourceIndex,
                    );
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        isVideo() {
            let dataType = this.dataType;
            return dataType === DataTypeEmu.VIDEO;
        },
        mainClass() {
            let cl = ['annotator-wrap '];
            if (this.isVideo) {
                cl.push('is-video');
            }
            return cl;
        },
        leftTitle() {
            let title = '图片列表';
            if (this.isVideo) {
                title = '视频列表';
            }
            return title;
        },
        accept() {
            // 上传能选择的文件类型
            let accept = 'image/*';
            let dataType = this.dataType;
            if (dataType === DataTypeEmu.VIDEO) {
                accept = 'video/*';
            } else if (dataType === DataTypeEmu.IMAGE) {
                accept = 'image/*';
            }
            return accept;
        },
        uploadParams() {
            // 上传参数
            let obj = {
                dataType: this.dataType,
                markId: this.markId,
            };
            return obj;
        },
        currentCategory() {
            let currentIndex = this.current.category;
            return this.getCategory(currentIndex);
        },
        currentAnnotation() {
            if (this.currentCategory == null) {
                return null;
            }
            let currentIndex = this.current.annotation;
            return this.currentCategory.getAnnotation(currentIndex);
        },
        swiperInstance() {
            return this.$refs.mySwiper.$swiper;
        },
        // 视频总时长
        duration() {
            let duration = this.currentSelectedSource.duration;
            let text = '';
            text = formatDuration(duration);
            return text;
        },
        frameAnnotations() {
            let list = [];
            let annotations = this.categoryFormData.annotations || [];
            list = annotations;
            return list;
        },
        // 事件是否可以编辑
        eventCanEdit() {
            let eventStatus = this.categoryFormData.eventStatus;
            return eventStatus === 1 || eventStatus === '1' || !eventStatus;
        },
    },
    created() {

    },
    methods: {
        onEventTypeChange(id) {
            let eventType = findTreeNode(id, eventTypeOptions.value);
            // console.log('event',this.categoryFormData)
            if (!this.categoryFormData?.id) this.categoryFormData.name = `${eventType?.name || ''}-${getNowTime()}`;
            // console.log('eventType',eventType)
            // 赋值接收部门，根据事件类型配置的接收部门
            this.categoryFormData.deptId = eventType && eventType.deptList?.length > 0 ? eventType.deptList[0].id : '';
        },

        changeArea(e) {
            console.log('changeArea', e);
            this.categoryFormData.areaId = e[1];
        },
        // 拾取弹窗
        showAmapVisible() {
            this.amapVisible = true;
            let thumbnail = this.getDataURL();
            this.categoryFormData = {
                ...this.categoryFormData,
                thumbnail,
            };
        },
        // 关联事件
        associatedEvents(val) {
            console.log('this.associatedEvents', val);
            let type = this.categoryFormData.eventTypeId;
            let txtType = type === '' ? '暂无历史事件分类，' : type !== val.eventTypeId ? '与历史事件分类不一致，' : '';
            let txt = `正在标注的事件${txtType}关联后，将自动调整为与历史事件分类一致`;
            this.$confirm(txt, '关联事件', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.$message({
                        type: 'success',
                        message: '确认关联，请保存事件!',
                    });
                    let eventHistoryIds = !val.eventHistoryIds ? val.id : `${val.id},${val.eventHistoryIds}`;
                    this.categoryFormData = {
                        ...this.categoryFormData,
                        eventTypeId: val.eventTypeId,
                        longitude: val.longitude,
                        latitude: val.latitude,
                        address: val.address,
                        area: val.area,
                        eventHistoryIds,
                    };
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消关联',
                    });
                });
        },
        bindEvent(item, index) {
            this.activityEventImg = index;
            this.eventStatus = true;
            // console.log('this.activityEventImg', this.activityEventImg);
            this.$refs.historyCarousel.setActiveItem(index);
        },
        getHappenTime(val) {
            let time = val.split(' ');
            return time[0];
        },
        /**
         * 切换幻灯片
         */
        historyChange(e) {
            this.activityImg = this.historyList[e].id;
            this.activityEventImg = this.eventStatus ? this.activityEventImg : 0;
        },
        /**
         * 选中历史图片
         */
        bindHistoryImg(val, index) {
            let obj = {};
            this.historyList.find((item, index) => {
                if (item.id === val) {
                    obj = {
                        ...item,
                        index,
                    };
                }
            });
            this.activityImg = obj.id;
            this.historyVal = this.getHappenTime(obj.createDate || obj.happenTime);
            this.$refs.historyCarousel.setActiveItem(obj.index);
        },

        /**
         * 通过照片ID获取当前照片对应网格航点的相关历史事件
         */
        getfindHistoryEventByGrid(id) {
            // '2cfecb23ef38431fb7d56f541f2e65c6'
            this.markerList = [];
            Api.getfindHistoryEventByGrid(id)
                .run()
                .then((res) => {
                    if (res) {
                        if (res.length > 0) {
                            this.markerList = res;
                        }
                    }
                });
        },

        // 通过照片ID获取当前照片的相关历史照片和事件
        gethistoryPictureAndEventList(id) {
            //  '2cfecb23ef38431fb7d56f541f2e65c6'
            this.historyPictureList = [];
            Api.gethistoryPictureAndEventList({ dataId: id, filteringItself: true })
                .run()
                .then((res) => {
                    if (res) {
                        if (res.length > 0) {
                            this.historyPictureList = res;
                            this.activityImg = res[0].id;
                            this.historyVal = this.getHappenTime(res[0].createDate);
                            this.historyList = [];
                            let list = [];
                            res.forEach((item) => {
                                if (item.eventList) {
                                    item.eventList.forEach((cell) => {
                                        list.push(cell);
                                    });
                                } else {
                                    list.push(item);
                                }
                            });
                            this.historyList = list;
                        } else {
                            this.$message({
                                message: '此图片暂无历史数据，请选择其他图片，或者使用标准模式新增标注事件',
                                type: 'warning',
                            });
                            this.modelType = 1;
                            this.$nextTick(() => {
                                this.initCanvas();
                            });
                        }
                    }
                });
        },

        /**
         * 选择对比模式
         */
        bindModelType(type) {
            this.modelType = type;
            this.$nextTick(() => {
                this.initCanvas();
            });
        },
        initCanvas() {
            let frame = this.$refs.annotatorFrame;
            let canvas = this.$refs.canvasEditor;
            this.modelHeight = canvas.offsetHeight;
            // let canvas = document.getElementById("editor");
            this.paper.setup(canvas);
            this.paper.view.viewSize = [this.paper.view.size.width, frame.offsetHeight];

            this.paper.activate();
            if (this.$refs.selectTool) {
                this.$refs.selectTool.click();
            }
            this.image.raster = new paper.Raster(this.image.url);

            this.image.raster.onLoad = () => {
                // 照片分辨率
                let width = this.image.raster.width;
                let height = this.image.raster.height;
                this.image.raster.sendToBack();
                this.fit();
                this.image.ratio = (width * height) / 1000000;

                let tempCtx = document.createElement('canvas').getContext('2d');
                tempCtx.canvas.width = width;
                tempCtx.canvas.height = height;
                // console.log(' tempCtx.canvas', tempCtx.canvas);

                tempCtx.drawImage(this.image.raster.image, 0, 0);
                this.image.data = tempCtx.getImageData(0, 0, width, height);
                let fontSize = width * 0.025;
                let positionTopLeft = new paper.Point(-width / 2, -height / 2 - fontSize * 0.5);
                const textColor = '#909399';

                if (!this.text.topLeft) {
                    this.text.topLeft = new paper.PointText(positionTopLeft);
                } else {
                    this.text.topLeft.remove();
                    // this.text.topLeft.position = positionTopLeft;
                    this.text.topLeft = new paper.PointText(positionTopLeft);
                }

                this.text.topLeft.fontSize = fontSize;
                // this.text.topLeft.fillColor = "white";
                this.text.topLeft.fillColor = textColor;
                this.text.topLeft.content = this.image.filename || '';

                let positionTopRight = new paper.Point(width / 2, height / 2 + fontSize * 1);
                if (!this.text.topRight) {
                    this.text.topRight = new paper.PointText(positionTopRight);
                } else {
                    // this.text.topRight.position = positionTopRight;
                    this.text.topRight.remove();
                    this.text.topRight = new paper.PointText(positionTopRight);
                }

                this.text.topRight.justification = 'right';
                this.text.topRight.fontSize = fontSize;
                this.text.topRight.fillColor = textColor;
                this.text.topRight.content = `${width} x ${height}`;
            };
        },
        fit() {
            let canvas = this.$refs.canvasEditor;
            let parentX = this.image.raster.width;
            let parentY = this.image.raster.height;
            let zoom = Math.min((canvas.width / parentX) * 0.95, (canvas.height / parentY) * 0.8);
            if (zoom >= 10) {
                zoom *= 0.5;
            } else if (zoom > 2) {
                zoom = 1;
            }
            this.paper.view.zoom = zoom;

            this.image.scale = 1 / this.paper.view.zoom;
            this.paper.view.setCenter(0, 0);
        },
        /**
         * 平移开始
         */
        onpinchstart(e) {
            // console.log(e);
            e.preventDefault();
            // if (!this.doneLoading) return;
            // let view = this.paper.view;
            this.pinching.old_zoom = this.paper.view.zoom;
            return false;
        },
        /**
         * 平移
         */
        onpinch(e) {
            // console.log(e);
            e.preventDefault();
            // if (!this.doneLoading) return;
            let view = this.paper.view;
            let viewPosition = view.viewToProject(new paper.Point(e.center.x, e.center.y));
            // eslint-disable-next-line camelcase
            let curr_zoom = e.scale * this.pinching.old_zoom;
            // eslint-disable-next-line camelcase
            let beta = this.paper.view.zoom / curr_zoom;
            let pc = viewPosition.subtract(this.paper.view.center);
            let a = viewPosition.subtract(pc.multiply(beta)).subtract(this.paper.view.center);
            let transform = { zoom: curr_zoom, offset: a };
            if (transform.zoom < 10 && transform.zoom > 0.01) {
                this.image.scale = 1 / transform.zoom;
                this.paper.view.zoom = transform.zoom;
                this.paper.view.center = view.center.add(transform.offset);
            }
            return false;
        },
        /**
         * 鼠标滚轮事件
         */
        onwheel(e) {
            e.preventDefault();
            let view = this.paper.view;
            if (e.ctrlKey) {
                // Pan up and down(上移、下移)
                let delta = new paper.Point(0, 0.5 * e.deltaY);
                this.paper.view.setCenter(view.center.add(delta));
            } else if (e.shiftKey) {
                // Pan left and right (左移、右移)
                let delta = new paper.Point(0.5 * e.deltaY, 0);
                this.paper.view.setCenter(view.center.add(delta));
            } else {
                let viewPosition = view.viewToProject(new paper.Point(e.offsetX, e.offsetY));

                let transform = this.changeZoom(e.deltaY, viewPosition);
                if (transform.zoom < 10 && transform.zoom > 0.01) {
                    this.image.scale = 1 / transform.zoom;
                    this.paper.view.zoom = transform.zoom;
                    this.paper.view.center = view.center.add(transform.offset);
                }
            }
            return false;
        },
        zoomIn() {
            let view = this.paper.view;
            let c = this.paper.view.center;
            let deltaY = -100;
            let transform = this.changeZoom(deltaY, c);
            if (transform.zoom < 10 && transform.zoom > 0.01) {
                this.image.scale = 1 / transform.zoom;
                this.paper.view.zoom = transform.zoom;
                this.paper.view.center = view.center.add(transform.offset);
            }
        },
        zoomOut() {
            let view = this.paper.view;
            let c = this.paper.view.center;
            let deltaY = 100;
            let transform = this.changeZoom(deltaY, c);
            if (transform.zoom < 10 && transform.zoom > 0.01) {
                this.image.scale = 1 / transform.zoom;
                this.paper.view.zoom = transform.zoom;
                this.paper.view.center = view.center.add(transform.offset);
            }
        },
        /**
         * 缩放
         */
        changeZoom(delta, p) {
            let oldZoom = this.paper.view.zoom;
            let c = this.paper.view.center;
            let factor = 1 + this.zoom;

            let zoom = delta < 0 ? oldZoom * factor : oldZoom / factor;
            let beta = oldZoom / zoom;
            let pc = p.subtract(c);
            let a = p.subtract(pc.multiply(beta)).subtract(c);

            return { zoom, offset: a };
        },
        /** 设置画布鼠标形态 */
        setCursor(newCursor) {
            this.cursor = newCursor;
        },
        /**
         * Current Annotation Operations
         * 当前标注操作
         * */
        uniteCurrentAnnotation(compound, simplify = true, undoable = true, isBBox = false) {
            if (this.isVideo) {
                let self = this;
                let formData = self.categoryFormData;
                let annotations = formData.annotations || [];
                let target = annotations.find((item) => item.id === this.currentFrame);
                // 当前帧不存在标注才新建标注
                if (!target) {
                    let annotaiton = this.createAnnotation();
                    formData.annotations.push(annotaiton);
                    let index = formData.annotations.length - 1;
                    self.current.annotation = index;
                    self.current.keypoint = index;
                }
            }
            this.$nextTick(() => {
                if (this.currentAnnotation == null) return;
                // if (this.currentAnnotation.hasChildren) {
                //     // 新建
                //     let newAnnotation = this.createAnnotation();
                //     let annotations = [].concat(this.categoryFormData.annotations);
                //     annotations.push(newAnnotation);
                //     this.categoryFormData.annotations = annotations;
                //     this.current.annotation = this.categoryFormData.annotations.length - 1;

                //     this.$nextTick(() => {
                //         this.currentAnnotation.unite(compound, simplify, undoable, isBBox);
                //     });
                //     return;
                // }
                this.currentAnnotation.unite(compound, simplify, undoable, isBBox);
            });
        },
        /**
         * 下载标注后的图片
         */
        downloadRasterImage() {
            const dataString = this.getDataURL();
            let oA = document.createElement('a');
            oA.download = ''; // 设置下载的文件名，默认是'下载'
            oA.href = dataString;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        /**
         * 导出图表图片，返回一个 base64 的 URL，可以设置为Image的src
         */
        getDataURL() {
            let project = this.paper.project;
            let layer = project.layers[0];
            let cloneLayer = layer.clone();
            cloneLayer.removeChildren(1, 3);
            let tempImg = cloneLayer.rasterize();
            let dataString = tempImg.toDataURL();
            tempImg.remove();
            cloneLayer.remove();
            return dataString;
        },
        /** 清空画布 */
        clear() {
            let project = this.paper.project;
            if (project) {
                let layer = project.layers[0];
                // console.log(layer);
                layer.removeChildren(3);
            }
        },
        getCategory(index) {
            if (index == null) return null;
            if (index < 0) return null;

            let ref = this.$refs.category;

            if (ref == null) return null;
            if (ref.length < 1 || index >= ref.length) return null;

            return this.$refs.category[index];
        },
        /**
         * 右侧事件信息初始化
         */
        CreateCategoryFormData() {
            // 事件名称 = 网格编号+日期+频次编号+事件编号
            let obj = {
                name: '',
                eventTypeId: '',
                address: '',
                source: 1, // 事件来源，使用dict_event_source（数据字典）
                happenTime: '',
                longitude: '',
                latitude: '',
                areaId: '',
                taskId: '',
                markId: this.markId || '',
                happenBy: this.userInfo.name,
                phone: this.userInfo.phone,
                collectDevice: '', // 采集设备
                remark: '',
                dataId: this.image.dataId || '',
                jurisdictionId: '', // 所属辖区id
                jurisdictionName: '', // 所属辖区名称
                // image: {
                //     id: '',
                //     url: '',
                // },
                images: [],
                thumbnail: '', // 缩略图
                annotations: [], // 标注
                markJson: '',
            };

            if (this.isVideo) {
                obj.images = this.currentSelectedSource.images;
            } else {
                obj.images = this.sourceList || [];
            }

            if (this.image.metadata) {
                let { longitude, latitude } = this.image.metadata;
                obj.longitude = longitude || '';
                obj.latitude = latitude || '';
                // if (longitude && latitude) {
                //     this.getAreaByLongitudeAndLatitude(longitude, latitude);
                // }

                obj.address = this.address;
            }
            if (this.currentSelectedSource) {
                if (this.currentSelectedSource.uavName) {
                    obj.collectDevice = this.currentSelectedSource.uavName;
                }
            }
            return obj;
        },

        /**
         * 组织markerjson
         */
        makeMarkerJson(data) {
            let annotations = data.annotations || [];
            let images = data.images || [];
            let imgList = [...images];
            if (this.isVideo) {
                // 去掉图片的base64
                for (let i = 0; i < imgList.length; i++) {
                    imgList[i].url = '';
                }
            }
            let obj = {
                images: imgList,
                annotations: [...annotations],
            };
            return obj;
        },
        /**
         * makerJson 字符串转对象
         */
        parseMarkerJson(jsonString) {
            if (!jsonString) return null;
            let obj = JSON.parse(jsonString);
            return obj;
        },
        // 新增事件
        async addCategory() {
            this.saveDraft();
            this.clear();
            this.editStatus = false;
            this.tooTStatus = true;
            // 原型上显示为缩率图 不存在imageUrl
            let imageUrl = this.image.imageUrl || this.image.url;
            if (imageUrl) {
                let area = null;
                let addr = null;
                let address = null;
                area = await getAreaInfo(
                    `${this.categoryFormData.longitude},${this.categoryFormData.latitude}`,
                );
                addr = JSON.parse(area.currentTarget.response).regeocode
                    && JSON.parse(area.currentTarget.response).regeocode.addressComponent;
                // setTimeout(async () => {
                if (!addr) {
                    area = await getAreaInfo(
                        `${this.categoryFormData.longitude},${this.categoryFormData.latitude}`,
                    );
                    addr = JSON.parse(area.currentTarget.response).regeocode
                        && JSON.parse(area.currentTarget.response).regeocode.addressComponent;
                }
                // }, 100);
                if (addr) {
                    let { district, township, streetNumber } = addr;
                    addr = district + township + streetNumber.street + streetNumber.number;
                    address = addr;
                }
                let obj = {
                    ...this.CreateCategoryFormData(),
                    latitude: this.categoryFormData.latitude,
                    longitude: this.categoryFormData.longitude,
                    address,
                    collectDevice: this.collectDevice,
                };
                obj.thumbnail = this.getDataURL();
                this.categoryFormData = obj;

                this.setArea();

                let annotaiton = this.createAnnotation();
                this.categoryFormData.annotations = [annotaiton];

                this.current.category = -1;
                this.current.annotation = -1;
                this.$nextTick(() => {
                    this.categories.unshift(obj);
                    this.current.category = 0;
                    this.current.annotation = 0;
                });
                // console.log('this.categoryFormData', this.categoryFormData);
                this.clearValidate();
            } else {
                let message = '请先选择要标注的图片';
                if (this.isVideo) {
                    message = '请先选择要标注的视频';
                }
                this.$message({
                    type: 'warning',
                    message,
                });
            }
            this.$nextTick(() => {
                this.activeTool = 'Polygon';
            });
        },
        /**
         * 清除表单校验提示
         */
        clearValidate() {
            if (this.$refs.cForm) {
                this.$nextTick(() => {
                    if (this.$refs.cForm) {
                        this.$refs.cForm.clearValidate();
                    }
                });
            }
        },
        /**
         * 创建标注
         */
        createAnnotation() {
            let width = this.image.raster.width;
            let height = this.image.raster.height;
            return {
                id: this.image.id,
                area: 0,
                bbox: [0, 0, 0, 0],
                category_id: '',
                // color: '#7D29C9',
                color: '#54CCFF01',
                creator: '',
                deleted: false,
                events: [],
                height,
                image_id: this.image.id,
                isbbox: false,
                iscrowd: false,
                keypoints: [],
                metadata: {},
                milliseconds: 0,
                paper_object: [],
                segmentation: [],
                width,
            };
        },
        beforeUpload(file) {
            let type = file.type;
            const valid = this.validFileType(type);
            return valid;
        },
        handleUpload(req) {
            let self = this;
            let file = req.file;
            let type = file.type;
        },
        /** 导入资源上传成功回调 */
        handleUploadSuccess(response, file, fileList) {
            if (response.result === 'true') {
                let data = response.data;
                let type = '';
                if (this.isVideo) {
                    type = 'video/';
                } else {
                    type = 'image/png';
                }
                let obj = {
                    url: data.filePath,
                    type,
                    filename: data.name,
                    dataId: data.dataId,
                    id: data.id,
                };
                // 往左侧资源列表添加资源
                this.sourceList.push(obj);
            }
        },

        validImage(type) {
            const pattern = /^image\/[a-zA-Z]{3,}/gi;
            return pattern.test(type);
        },
        /**
         * 校验文件格式
         */
        validFileType(type) {
            let pattern = /^image\/[a-zA-Z]{3,}/gi;
            let accept = this.accept;
            if (accept) {
                if (accept.indexOf('image') !== -1) {
                    pattern = /^image\/[a-zA-Z]{3,}/gi;
                } else if (accept.indexOf('video') !== -1) {
                    pattern = /^video\/[a-zA-Z0-9]{3,}/gi;
                }
            }
            return pattern.test(type);
        },
        /**
         * 左边资源点击
         */
        handleSourceClick(item, index, num) {
            this.currentSelectedSourceIndex = index;
            this.currentSelectedSource = item;
            this.sourceId = item.dataId || '';
            let type = item.type;
            const isImage = this.validImage(type);
            console.log('num', num);
            this.editStatus = num !== 1;
            this.saveDraft();
            if (this.modelType === 2) {
                this.gethistoryPictureAndEventList(this.sourceId);
            } else if (this.modelType === 3) {
                this.getfindHistoryEventByGrid(this.sourceId);
            }
            this.current = {
                category: -1,
                annotation: -1,
                keypoint: -1,
            };
            this.categoryFormData = this.CreateCategoryFormData();
            this.clearValidate();
            if (isImage) {
                this.historyId = item.id; // 历史事件id
                this.image.url = item.url;
                this.image.imageUrl = item.imageUrl;
                this.image.raster.source = item.url;
                this.image.filename = item.filename;
                this.image.dataId = item.dataId;
                this.image.id = item.id;
                // console.log('sadgasgdagdash', num);
                // 事件列表点击不需要重新解析图片
                if (num !== 1) {
                    // 解析图片元数据获取Gps信息
                    ExifUtil.getGPS(item.url, async (gpsInfo) => {
                        if (gpsInfo) {
                            let { longitude, latitude, Make, Model } = gpsInfo;
                            this.categoryFormData.longitude = longitude || this.categoryFormData.longitude;
                            this.categoryFormData.latitude = latitude || this.categoryFormData.latitude;
                            this.categoryFormData.collectDevice = Make && Model ? `${Make}-${Model}` : this.categoryFormData.collectDevice;

                            this.collectDevice = `${Make}-${Model}`;
                            // if (this.categoryFormData.longitude && this.categoryFormData.latitude) {
                            //     this.getAreaByLongitudeAndLatitude(
                            //         this.categoryFormData.longitude,
                            //         this.categoryFormData.latitude,
                            //     );
                            // }
                            let address = null;
                            let area = await getAreaInfo(`${longitude},${latitude}`);
                            address = JSON.parse(area.currentTarget.response).regeocode
                                && JSON.parse(area.currentTarget.response).regeocode.addressComponent;
                            // setTimeout(async () => {
                            if (!address) {
                                area = await getAreaInfo(
                                    `${this.categoryFormData.longitude},${this.categoryFormData.latitude}`,
                                );
                                address = JSON.parse(area.currentTarget.response).regeocode
                                    && JSON.parse(area.currentTarget.response).regeocode.addressComponent;
                            }
                            // }, 1000);
                            if (address) {
                                let { district, township, streetNumber } = address;
                                address = district + township + streetNumber.street + streetNumber.number;
                                this.image.metadata.longitude = longitude;
                                this.image.metadata.latitude = latitude;
                                if (!this.categoryFormData.address) {
                                    this.address = address;
                                    this.categoryFormData.address = address;
                                }
                            }
                            // num !== 1 && this.addCategory();
                        }
                    });
                }
            } else {
                let vurl = item.url;
                this.captureVideoFrameIng = true;
                this.currentFrame = 0;
                FileUtil.getFileFromUrl(vurl).then((resFile) => {
                    // 如果资源没有视频文件，设置file属性，这样不用重复请求视频
                    if (!item.file) {
                        item.file = resFile;
                    }
                    window.webCapture.capture(resFile, 0, (dataURL, imageInfo) => {
                        const { width, height, duration, frameCount } = imageInfo;
                        this.image.url = dataURL;
                        this.image.raster.source = dataURL;
                        this.image.id = 0;
                        this.image.dataId = item.dataId;
                        this.endFrame = frameCount;
                        this.$set(item, 'duration', duration);
                        if (!item.images || item.images.length <= 0) {
                            let imageList = [];
                            for (let i = 0; i < frameCount; i++) {
                                let obj = {
                                    url: '',
                                    type: 'image/png',
                                    filename: `frame_${i}.png`,
                                    dataId: item.dataId,
                                    id: i,
                                };
                                if (i === 0) {
                                    obj.url = dataURL;
                                }
                                imageList.push(obj);
                            }

                            item.images = imageList;
                        }
                        this.captureVideoFrameIng = false;
                    });
                });
            }
        },

        /**
         * 删除左边资源
         */
        handleDeleteAsset(data) {
            this.$confirm('是否确定删除该资源?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'c-confirm-dialog',
            }).then(() => {
                let id = data.id;
                Api.fetchDeleteAssetById(id)
                    .run()
                    .then((res) => {
                        this.sourceList = this.sourceList.filter((source) => source.id !== id);
                    });
            });
        },

        /**
         * 事件点击
         */
        onCategoryClick(data, index) {
            if (!data) return;
            this.editStatus = false;
            if (index !== this.current.category) {
                this.saveDraft();
                this.clear();
                if (this.isVideo) {
                    if (data.images) {
                        let image = data.images[0];
                        if (image) {
                            let dataId = image.dataId;
                            for (let i = 0; i < this.sourceList.length; i++) {
                                if (this.sourceList[i].dataId === dataId) {
                                    this.handleSourceClick(this.sourceList[i], i, 1);
                                    break;
                                }
                            }
                        }
                    }
                } else {
                    let imageId = data.images[0].id;
                    let annotations = data.annotations || [];
                    let annotation = annotations[0];
                    if (annotation) {
                        imageId = annotation.image_id;
                    }
                    let tImage = data.images.find((item) => item.id === imageId);
                    if (tImage) {
                        let haveSource = false;
                        for (let i = 0; i < this.sourceList.length; i++) {
                            if (this.sourceList[i].dataId === tImage.dataId) {
                                this.handleSourceClick(this.sourceList[i], i, 1);
                                haveSource = true;
                                break;
                            }
                        }
                        if (!haveSource) {
                            let url = tImage.url;
                            this.image.raster.source = url;
                            this.image.url = url;
                            this.image.id = tImage.id;
                            this.image.dataId = tImage.dataId;
                        }
                    }
                }

                this.current.category = index;
                if (data.annotations) {
                    if (data.annotations.length > 0) {
                        this.current.annotation = 0;
                    }
                }
                if (index > -1) {
                    this.categoryFormData = data;
                    this.tooTStatus = true;
                }

                this.clearValidate();
                // if (data && data.image) {
                //     let url = data.image.url;
                //     this.image.raster.source = url;
                // }
                if (data && data.images) {
                    if (data.images.length > 0) {
                        if (this.isVideo) {
                            // todo
                            let annotations = data.annotations || [];
                            let annotation = annotations[0];
                            if (annotation) {
                                // 为什么加定时器？解决上方handleSourceClick 异步执行的时差影响
                                let interval = null;
                                interval = setInterval(() => {
                                    if (!this.captureVideoFrameIng) {
                                        clearInterval(interval);
                                        this.handleFrameCardClick(annotation, 0);
                                    }
                                }, 100);
                            }
                        } else {
                            // let url = data.images[0].url;
                            // this.image.raster.source = url;
                            // this.image.url = url;
                            // let imageId = data.images[0].id;
                            // let annotations = data.annotations || [];
                            // let annotation = annotations[0];
                            // if (annotation) {
                            //     imageId = annotation.image_id;
                            // }
                            // let tImage = data.images.find((item) => item.id === imageId);
                            // if (tImage) {
                            //     let url = tImage.url;
                            //     this.image.raster.source = url;
                            //     this.image.url = url;
                            //     this.image.id = tImage.id;
                            //     this.image.dataId = tImage.dataId;
                            // }
                        }
                    }
                }
                if (this.$refs.category) {
                    let categoryCom = this.$refs.category[index];
                    // console.log(data);
                    if (categoryCom) {
                        this.categories[index].annotations = data.annotations;
                        categoryCom.updateAnnotations();
                    }
                }
            }
            // 默认选中多边形标注模式
            this.activeTool = 'Polygon';
            this.$nextTick(() => {
                this.goAnchor(
                    `sourceItem${this.currentSelectedSourceIndex}`,
                    this.currentSelectedSourceIndex,
                );
            });
        },
        /**
         * 删除事件
         */

        onCategoryDownloadClick(data, index) {
            let oA = document.createElement('a');
            oA.download = ''; // 设置下载的文件名，默认是'下载'
            oA.href = data.thumbnail;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        onCategoryDeleteClick(data, index) {
            let message = '删除成功!';
            let messageType = 'success';

            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                customClass: 'c-confirm-dialog',
            })
                .then(() => {
                    let id = data.id;
                    let remove = () => {
                        this.categories.splice(index, 1);
                        this.current = {
                            category: -1,
                            // annotation: -1,
                            annotation: -1,
                            keypoint: -1,
                        };
                        this.resetFormData();
                        this.$message({
                            type: messageType,
                            message,
                        });
                    };
                    if (!id) {
                        // 如果没有id不用调接口删除
                        remove();
                    } else {
                        Api.fetchDeleteEventById(id)
                            .run()
                            .then((res) => {
                                if (res) {
                                    messageType = 'error';
                                    message = '删除失败';
                                    this.$message({
                                        type: messageType,
                                        message,
                                    });
                                    return;
                                }
                                remove();
                            });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },

        /**
         * 帧改变
         */
        handleChangeFrame(frame) {
            let videoUrl = this.currentSelectedSource.url;
            let self = this;
            const resetCurrent = ({ dataURL, imageInfo }) => {
                const { width, height, duration, frameCount } = imageInfo;
                this.image.url = dataURL;
                this.image.raster.source = dataURL;
                this.image.id = frame;
                this.endFrame = frameCount;
                let images = this.currentSelectedSource.images || [];
                for (let i = 0; i < images.length; i++) {
                    if (images[i].id === frame) {
                        images[i].url = dataURL;
                    }
                }

                let annotations = this.categoryFormData.annotations || [];
                let targetIndex = -1;
                for (let i = 0; i < annotations.length; i++) {
                    // 查找当前帧是否已经存在标注，存在就设置当前标注为当前帧的标注
                    if (annotations[i].id === frame) {
                        targetIndex = i;
                        break;
                    }
                }
                self.current.annotation = targetIndex;
                self.current.keypoint = targetIndex;
            };
            if (this.currentSelectedSource.file instanceof File) {
                this.captureVideoFrame(this.currentSelectedSource.file, frame).then(
                    ({ dataURL, imageInfo }) => {
                        resetCurrent({ dataURL, imageInfo });
                    },
                );
            } else {
                this.captureVideoFrame(videoUrl, frame).then(({ dataURL, imageInfo }) => {
                    resetCurrent({ dataURL, imageInfo });
                });
            }
        },

        // 底部帧标注缩略图点击
        handleFrameCardClick(data, index) {
            let image = this.getFrameImage(data.image_id);
            if (image) {
                // 设置当前显示的图片为当前帧的图片
                this.image.url = image.url;
                this.image.raster.source = image.url;
                this.image.id = image.id;
            }

            this.current.annotation = index;
            this.current.keypoint = index;

            this.currentFrame = data.id;
        },

        /**
         * 删除帧标注
         */
        handleFrameCardDeleteClick(data, index) {
            this.$confirm('是否确定删除该帧标注?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                customClass: 'c-confirm-dialog',
            }).then(() => {
                let annotations = this.categoryFormData.annotations || [];
                annotations.splice(index, 1);
                this.current.annotation = -1;
                this.current.keypoint = -1;
            });
        },

        /**
         * 查找标注帧的原图片
         */
        getFrameImage(frame) {
            let images = this.currentSelectedSource.images || [];
            let target = '';
            for (let i = 0; i < images.length; i++) {
                let image = images[i];
                if (image.id === frame) {
                    target = image;
                    break;
                }
            }
            return target;
        },

        /**
         * 视频截图
         */
        async captureVideoFrame(videoUrl, frame = 0) {
            const capture = (file, vframe, resolve) => {
                window.webCapture.capture(file, vframe, (dataURL, imageInfo) => {
                    resolve({ dataURL, imageInfo });
                });
            };
            return new Promise((resolve) => {
                if (videoUrl instanceof File) {
                    capture(videoUrl, frame, resolve);
                } else {
                    FileUtil.getFileFromUrl(videoUrl).then((resFile) => {
                        capture(resFile, frame, resolve);
                    });
                }
            });
        },
        /**
         * 获取标注任务列表
         */
        async getTaskData() {
            let markId = this.markId;
            let data = {};

            if (markId) {
                await Api.fetchTaskData(markId)
                    .run()
                    .then((res) => {
                        let sourceList = [];
                        data = res || {};
                        let dataType = data.dataType;
                        this.dataType = dataType;
                        let type = 'image/png';
                        if (dataType === DataTypeEmu.IMAGE) {
                            type = 'image/png';
                        } else if (dataType === DataTypeEmu.VIDEO) {
                            type = 'video/';
                        }

                        // 解析左边资源列表
                        let dataList = data.dataList || [];
                        dataList.forEach((item) => {
                            let obj = {
                                ...item,
                                dataId: item.dataId,
                                id: item.id,
                                checkStatus: item.checkStatus,
                                url: item.filePath,
                                type,
                                filename: item.name,
                            };
                            sourceList.push(obj);
                        });
                        if (data.markIndex) {
                            if (sourceList.length > data.markIndex) {
                                this.currentSelectedSourceIndex = data.markIndex;
                            } else {
                                this.currentSelectedSourceIndex = this.currentSelectedSourceIndex.length;
                            }
                        } else {
                            this.currentSelectedSourceIndex = 0;
                        }

                        this.sourceList = [];
                        this.sourceList = sourceList;
                        // 解析事件列表
                        let eventList = data.eventList || [];
                        eventList.forEach((item, eventIndex) => {
                            let markJson = item.markJson;
                            markJson = this.parseMarkerJson(markJson) || {};
                            if (item.area) {
                                if (typeof item.area === 'string') {
                                    if (item.area !== '') {
                                        item.area = JSON.parse(item.area);
                                    }
                                }
                            }

                            // eslint-disable-next-line no-param-reassign
                            item.annotations = markJson.annotations || [];
                            item.annotations.map((annotationItem) => {
                                if (annotationItem.color === '#54CCFF') {
                                    annotationItem.color = '#54CCFF01';
                                }
                            });
                            // eslint-disable-next-line no-param-reassign
                            item.images = markJson.images;

                            // 格式化事件类型
                            let eventTypeId = item.eventTypeId;
                            let parentEventTypeId = item.parentEventTypeId;
                            if (
                                eventTypeId !== undefined
                                && eventTypeId !== ''
                                && parentEventTypeId !== undefined
                                && parentEventTypeId !== ''
                            ) {
                                item.eventTypeId = [parentEventTypeId, eventTypeId];
                            }
                        });
                        this.categories = [];
                        this.$nextTick(() => {
                            this.categories = eventList;
                            // if (this.categories.length > 0) {
                            //     if (this.isVideo) {
                            //         this.initAnnotationImage();
                            //     } else {
                            //         this.onCategoryClick(this.categories[0], -2);
                            //     }
                            // }
                            // 触发resize事件，解决paperjs 初始化鼠标偏移问题
                            this.dispatchResize();
                            this.goAnchor(
                                `sourceItem${this.currentSelectedSourceIndex}`,
                                this.currentSelectedSourceIndex,
                            );
                        });
                    });
            }
        },
        // 锚点跳转
        goAnchor(selector, index) {
            this.$nextTick(() => {
                // console.log(' document.getElementById(selector)', document.getElementById(selector));
                document.getElementById(selector)
                    && document.getElementById(selector).scrollIntoView({ behavior: 'smooth' });
                // this.$refs[selector][0].scrollIntoView({ behavior: 'smooth' });
            });
        },

        async initAnnotationImage() {
            let categories = this.categories || [];
            for (let i = 0; i < categories.length; i++) {
                let category = categories[i];
                let images = category.images || [];
                let annotations = category.annotations || [];
                if (images.length > 0) {
                    let dataId = images[0].dataId;
                    let sourceItem = this.sourceList.find((source, sourceIndex) => source.dataId === dataId);
                    if (sourceItem) {
                        let filePath = sourceItem.url;

                        for (let j = 0; j < annotations.length; j++) {
                            let annotation = annotations[j];
                            let imageId = annotation.image_id;
                            // eslint-disable-next-line no-await-in-loop
                            let res = await this.captureVideoFrame(filePath, imageId);
                            if (res) {
                                for (let k = 0; k < images.length; k++) {
                                    if (images[k].id === imageId) {
                                        images[k].url = res.dataURL;
                                        break;
                                    }
                                }
                            }
                        }
                        sourceItem.images = images;
                    }
                }
            }
            this.onCategoryClick(this.categories[0], 0);
        },
        /**
         * 保存
         */
        save() {
            let data = {};
            const current = this.current.category;
            if (this.$refs.category) {
                let categoryComponent = this.$refs.category[current];
                if (categoryComponent) {
                    let categoryData = categoryComponent.export();
                    // console.log('categoryData', categoryData);
                    // console.log('this.categoryFormData', this.categoryFormData);
                    // this.categoryFormData.latitude
                    data = {
                        ...categoryData,
                        name: this.categoryFormData.name,
                        areaId: this.categoryFormData.areaId,
                        areaName: this.categoryFormData.areaName,
                        address: this.categoryFormData.address,
                        id: this.categoryFormData.id || null,
                        jurisdictionId: this.categoryFormData.jurisdictionId,
                        jurisdictionName: this.categoryFormData.jurisdictionName,
                        longitude: this.categoryFormData.longitude,
                        latitude: this.categoryFormData.latitude,
                        phone: this.categoryFormData.phone,
                        remark: this.categoryFormData.remark,
                        eventHistoryIds: this.categoryFormData.eventHistoryIds,
                        eventTypeId: this.categoryFormData.eventTypeId,
                        happenTime: this.getTime(),

                    };
                    if (Array.isArray(data.eventTypeId)) {
                        data.eventTypeId = data.eventTypeId[1] || '';
                    }

                    delete data.thumbnail;

                    // data.markJson = JSON.stringify(annotations);

                    // makeMarkerJson 标注事件的框框数据等
                    let markJson = this.makeMarkerJson(data) || {};
                    data.markJson = JSON.stringify(markJson);
                    if (data.area) {
                        if (typeof data.area !== 'string') {
                            data.area = JSON.stringify(data.area);
                        }
                    }
                    delete data.annotations;
                    delete data.images;
                    console.log('datadatadatadatadata', data);
                    if (this.$refs.cForm) {
                        this.$refs.cForm.validate((valid) => {
                            this.disabled = true;
                            if (valid) {
                                Api.fetchSaveEvent(data)
                                    .run()
                                    .then((res) => {
                                        this.disabled = false;
                                        if (res) {
                                            this.categoryFormData.id = res.id;
                                            this.$message({
                                                type: 'success',
                                                message: '保存成功',
                                            });
                                            this.getUpdateMarkIndex(
                                                this.markId,
                                                this.currentSelectedSourceIndex,
                                            );
                                            this.resetFormData();
                                            this.editStatus = true;
                                            if (this.categories[current]) {
                                                categoryData.thumbnail = this.getDataURL();
                                                this.$set(this.categories, current, {
                                                    ...categoryData,
                                                    ...res,
                                                });
                                            }
                                        }
                                    });
                            }
                        });
                    }
                }
            }
            setTimeout(() => {
                this.disabled = false;
            }, 20 * 1000);
        },
        // 查询数据下标
        getUpdateMarkIndex(id, markIndex) {
            Api.updateMarkIndex({
                id,
                markIndex,
            })
                .run()
                .then((res) => {
                    // this.currentSelectedSourceInde = res.markIndex;
                });
        },

        getTime(val) {
            let time = {};
            let now = new Date(); // 当前日期
            let nowDay = now.getDate(); // 当前日
            let nowMonth = now.getMonth() + 1; // 当前月
            let nowYear = now.getFullYear(); // 当前年
            let nowHours = now.getHours(); // 获取时
            let nowMinutes = now.getMinutes(); // 获取分
            let nowSeconds = now.getSeconds(); // 获取秒
            let Month = nowMonth < 10 ? `0${nowMonth}` : nowMonth;
            let Day = nowDay < 10 ? `0${nowDay}` : nowDay;
            let Hours = nowHours < 10 ? `0${nowHours}` : nowHours;
            let Minutes = nowMinutes < 10 ? `0${nowMinutes}` : nowMinutes;
            let Seconds = nowSeconds < 10 ? `0${nowSeconds}` : nowSeconds;
            time = `${nowYear}-${Month}-${Day} ${Hours}:${Minutes}:${Seconds}`;
            return time;
        },

        /**
         * 存草稿
         */
        saveDraft() {
            const current = this.current.category;
            if (this.$refs.category) {
                let categoryComponent = this.$refs.category[current];
                if (categoryComponent) {
                    let categoryData = categoryComponent.export();
                    if (this.categories[current]) {
                        this.$set(this.categories, current, categoryData);
                        this.categoryFormData = categoryData;
                    }
                }
            }
        },
        // 重置
        resetFormData() {
            this.categoryFormData = this.CreateCategoryFormData();
            this.$nextTick(() => {
                this.clearValidate();
            });
        },
        /**
         * 右侧经纬度信息输入
         */
        // handleInput(event) {
        //     let longitude = '';
        //     let latitude = '';
        //     let value = event;
        //     if (value) {
        //         value = value.split(',');
        //         longitude = value[0] || '';
        //         latitude = value[1] || '';
        //     }
        //     this.categoryFormData.longitude = longitude;
        //     this.categoryFormData.latitude = latitude;
        //     console.log(value);
        // },
        // 经纬度输入框值改变
        handleLngLatChange(e) {
            this.setArea();
            this.getAreaByLongitudeAndLatitude(e);
        },
        // 拾取位置完毕
        handlePickPositionOk(position, address) {
            if (Array.isArray(position)) {
                if (position.length > 0) {
                    let lng = position[0];
                    let lat = position[1];
                    this.categoryFormData.longitude = lng;
                    this.categoryFormData.latitude = lat;
                    this.categoryFormData.address = address || this.categoryFormData.address;
                    this.getAreaByLongitudeAndLatitude(lng, lat);
                    this.getEventJurisdiction(lng, lat);
                    this.setArea();
                    if (this.$refs.cForm) {
                        this.$refs.cForm.validateField('longitude');
                    }
                }
            }
        },
        // 设置categoryFormData 的area字段 //此方法是给后台回显使用
        setArea() {
            const { longitude, latitude, address } = this.categoryFormData;
            if (longitude && latitude) {
                let area = [
                    {
                        type: 'circle',
                        radius: 0,
                        area: 0,
                        longitude,
                        latitude,
                        name: address,
                    },
                ];
                this.categoryFormData.area = area;
            }
        },
        /**
         * 获取事件类型
         */
        getEventType() {
            Api.fetchEventTye()
                .run()
                .then((res) => {
                    // console.log(res);
                    let list = res || [];
                    this.eventOptions = list;
                });
        },
        /**
         * 格式化时长
         */
        durationFormat(duration) {
            let res = formatDuration(duration);
            return res;
        },
        /**
         * 解析路由参数
         */
        parseRoute() {
            let routeParams = this.$route.params || {};
            let id = routeParams.id;
            this.markId = id;
        },
        // 根据经纬度查询所属区域
        getAreaByLongitudeAndLatitude(longitude, latitude) {
            const self = this;
            Api.getAreaByLongitudeAndLatitude({ longitude, latitude })
                .run()
                .then((res) => {
                    // console.log('所属区域：', res);
                    if (res) {
                        if (res.id) {
                            this.categoryFormData.areaId = res.id;
                        } else {
                            this.$message({
                                message: '您修改的经纬度识别所属区域错误，请修改经纬度或所属区域',
                                type: 'warning',
                            });
                        }
                    }
                });
        },

        // 获取所属区域
        getAreaFindList() {
            const self = this;
            Api.getAreaFindList({})
                .run()
                .then((res) => {
                    this.areaList = res;
                    // console.log('asgasgsagas', res);
                });
        },
        // 获取所属辖区
        getJurisdictionFindList() {
            const self = this;
            Api.getJurisdictionFindList({})
                .run()
                .then((res) => {
                    this.jurisdictionList = res;
                    console.log('jurisdictionList', this.jurisdictionList);
                });
        },

        getEventJurisdiction(longitude, latitude) {
            const self = this;
            Api.getEventJurisdiction({ longitude, latitude })
                .run()
                .then((res) => {
                    // console.log('所属辖区：', res);
                    if (res) {
                        if (res.id) {
                            this.categoryFormData.jurisdictionId = res.id;
                            this.categoryFormData.jurisdictionName = res.name;
                        } else {
                            this.$message({
                                message: '您修改的经纬度识别所属辖区错误，请修改经纬度',
                                type: 'warning',
                            });
                        }
                    }
                });
        },

        getUserInfo() {
            const self = this;
            let token = window.getCookie('access_token');
            function parseJwt(tokenData) {
                let base64Url = tokenData.split('.')[1];
                let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                return JSON.parse(decodeURIComponent(window.atob(base64)));
            }
            let user = parseJwt(token);
            if (user) {
                let id = user.user_name || user.id;
                let param = {
                    id,
                };
                Api.fetchUserById(param)
                    .run()
                    .then((res) => {
                        let data = res || {};
                        self.userInfo = {
                            ...data,
                            phone: data.user.phone1,
                        };
                    });
            }
        },
        onWindowResize() { },
        dispatchResize() {
            this.$nextTick(() => {
                let evt = document.createEvent('Event');
                evt.initEvent('resize', true, true);
                // let evt = new Event('resize', { bubbles: true, cancelable: false });
                let canvas = this.$refs.canvasEditor;
                if (canvas) {
                    canvas.dispatchEvent(evt);
                }
            });
        },
        handleStep(e) {
            let topIndex = this.currentSelectedSourceIndex;
            let leftIndex = this.current.category;
            let res = null;
            let ctrlKey = e.ctrlKey;

            // eslint-disable-next-line default-case
            switch (e.keyCode) {
                case 37: // 左键
                    if (ctrlKey) {
                        if (leftIndex === 0) {
                            this.$message.warning('已是第一张图片');
                            return;
                        }
                        // eslint-disable-next-line no-case-declarations
                        res = --leftIndex;
                        this.onCategoryClick(this.categories[res], res);
                    }

                    break;
                case 38: // 上键
                    if (ctrlKey) {
                        if (topIndex === 0) {
                            this.$message.warning('已是第一张图片');
                            return;
                        }
                        res = --topIndex;
                        this.handleSourceClick(this.sourceList[res], res);
                    }
                    break;
                case 39: // 右键
                    if (ctrlKey) {
                        if (leftIndex === this.categories.length - 1) {
                            this.$message.warning('已是最后一张图片');
                            return;
                        }
                        res = ++leftIndex;
                        this.onCategoryClick(this.categories[res], res);
                    }

                    break;
                case 40: // 下键
                    if (ctrlKey) {
                        if (topIndex === this.sourceList.length - 1) {
                            this.$message.warning('已是最后一张图片');
                            return;
                        }
                        res = ++topIndex;
                        this.handleSourceClick(this.sourceList[res], res);
                    }

                    break;
            }
            // ctrl+s 快捷键
            if (ctrlKey && e.keyCode === 83) {
                e.returnValue = false; // 阻止直接保存网页
                this.save();
                // eslint-disable-next-line consistent-return
                return false;
            }
        },
        imgScaleHandle(zoom) {
            this.historySize += zoom;
            if (this.historySize < -0.5) {
                this.historySize = -0.5;
            }
            this.historyScale = `scale(${1 + this.historySize}) rotateZ(${this.historyDeg}deg)`;
            // console.log('this.historyScale', this.historyScale);
        },
        /**
         * 鼠标滚动 实现放大缩小
         */
        wheelHandle(e) {
            e.preventDefault();
            const ev = e || window.event; // 兼容性处理 => 火狐浏览器判断滚轮的方向是属性 detail，谷歌和ie浏览器判断滚轮滚动的方向是属性 wheelDelta
            // dir = -dir; // dir > 0 => 表示的滚轮是向上滚动，否则是向下滚动 => 范围 (-120 ~ 120)
            const dir = ev.detail ? ev.detail * -120 : ev.wheelDelta;
            // 滚动的数值 / 2000 => 表示滚动的比例，用此比例作为图片缩放的比例
            this.imgScaleHandle(dir / 2000);
        },
        /**
         * 处理图片拖动
         */
        onmousedownHandle(e) {
            const that = this;
            this.$refs.historyBox[this.currentSelectedSourceIndex].onmousemove = function (el) {
                const ev = el || window.event; // 阻止默认事件
                ev.preventDefault();
                that.historyLeft += ev.movementX;
                that.historyTop += ev.movementY;
            };
            this.$refs.historyBox[this.currentSelectedSourceIndex].onmouseup = function () {
                // 鼠标抬起时将操作区域的鼠标按下和抬起事件置为null 并初始化
                that.$refs.historyBox[this.currentSelectedSourceIndex].onmousemove = null;
                that.$refs.historyBox[this.currentSelectedSourceIndex].onmouseup = null;
            };
            if (e.preventDefault) {
                e.preventDefault();
            } else {
                return false;
            }
            return false;
        },
    },

    created() {
        this.categoryFormData = this.CreateCategoryFormData();
        this.paper = new paper.PaperScope();
        this.parseRoute();
        this.getEventType();
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.initCanvas();
                this.getTaskData();
                this.getAreaFindList();
                this.getJurisdictionFindList();
                this.mousewheelevt = /Firefox/i.test(navigator.userAgent) ? 'DOMMouseScroll' : 'mousewheel';
                // 为空间区域绑定鼠标滚轮事件 =》 处理函数是wheelHandle
                // 如果你监听了window的scroll或者touchmove事件，你应该把passive设置为true，这样滚动就会流畅很多
            }, 50);
        });
        this.getUserInfo();
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('keydown', (e) => this.handleStep(e));
        // 兼容火狐浏览器
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('keydown', this.handleStep);
        this.slideList.forEach((item, index) => {
            // 取消监听
            this.$refs.historyBox[index].removeEventListener(this.mousewheelevt, this.wheelHandle);
        });
    },
};
</script>

<style lang="scss" scoped>
.annotator-wrap {
    height: 100vh;
    /* background-color: #f3f4f6; */
    background-color: #f0f2f5;
}

.toolbar-wrap {
    /* background-color: #4b5162; */
    /* background-color: #f1f1f1; */
    background-color: #fff;
    border-bottom: 1px solid #e7e7e7;
}

.toolbar-wrap__horizontal {
    display: flex;
    box-sizing: border-box;
    height: 40px;
    align-items: center;
    justify-content: space-between;

    .annotator-Tool {
        display: flex;
        flex: 1;
    }

    .annotator-model {
        display: flex;
        color: white;
        font-size: 14px;
        margin-right: 15px;

        .model-1 {
            cursor: pointer;
            height: 26px;
            line-height: 26px;
            background: rgba(29, 33, 45, 0.6);
            border-radius: 2px 2px 2px 2px;
            padding: 2px 5px;
            margin: 0 5px;
        }

        .model-activity {
            background: #2e7df8;
        }
    }
}

.toolbar-wrap__horizontal .annotator-tool-item {
    margin-left: 16px;
}

.toolbar-wrap__horizontal .annotator-tool-item .toolbar-icon {
    display: inline-block;
    height: 24px;
    width: auto;
}

.annotator-wrap-middle {
    display: block;
    height: 100%;
    /* position: relative; */
}

.annotator-middle-panel {
    display: block;
    width: inherit;
    height: calc(100% - 40px - 50px - 160px);
    /* background-color: #7c818c; */
    /* background-color: #f3f4f6; */
    background-color: #f0f2f5;
    overflow: hidden;
    position: relative;
    display: flex;
}

.annotator-frame {
    margin: 0;
    height: 100%;
    position: relative;
}

.annotator-model-main {
    width: 50%;
    height: 100%;
    border-left: 3px white solid;
    position: relative;
    overflow: hidden;

    .annotator-model-contrast {
        height: 100%;

        .annotator-img-main {
            width: 100%;
            height: 100%;
            position: absolute;

            ::v-deep .el-carousel__container {
                height: 100%;
            }

            .annotator-carousel {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .history-event-img {
            position: absolute;
            bottom: 1%;
            left: 2.5%;
            right: 2.5%;
            height: 110px;
            z-index: 11;
            background: rgba(29, 33, 45, 0.6) !important;
            display: flex;

            .event-main {
                width: 90px;
                height: 100px;
                background: #e7e7e7;
                margin: 5px;
                font-size: 12px;
                text-align: center;

                .event-img {
                    height: 80px;
                    width: 80px;
                    border-radius: 4px;
                    margin-top: 5px;
                    cursor: pointer;
                }
            }

            .event-img-activity {
                color: white;
                background: #2e7df8;
            }
        }

        .history-main {
            position: absolute;
            top: 3%;
            right: 3%;
            z-index: 10;
            background: rgba(29, 33, 45, 0.6) !important;
            width: 140px;
            line-height: 36px;
            color: white;

            .history-title {
                display: flex;
                text-align: center;
                cursor: pointer;

                .history-txt {
                    flex: 4;
                }

                .history-i {
                    flex: 1;
                    display: inline-block;
                    line-height: 36px;
                }
            }
        }
    }

    .annotator-model-map {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
}

.event-main {
    .event-mask {
        width: 250px;
        height: 330px;
        background: white;

        .event-li {
            line-height: 25px;
            height: 25px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
        }

        .event-type {
            font-weight: 600;
            font-size: 16px;
        }

        .event-btn {
            width: 250px;
        }

        .event-img {
            width: 250px;
        }

        span {
            display: inline-block;
            color: rgba(29, 33, 45, 0.6);
        }
    }
}

.history-list {
    height: 60vh;
    overflow: hidden;
    background-color: rgba(29, 33, 45, 0.6);
    margin-bottom: 30px;
}

.annotator-canvas {
    display: block;
    width: 100%;
    height: 100%;
}

canvas[resize] {
    width: 100%;
    height: 100%;
}

.left-panel {
    width: 288px;
    float: left;
    height: inherit;
    background: #fff;
    border: 1px solid #e7e7e7;
}

.left-panel__content {
    height: 100%;
}

::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}

.left-panel .left-panel__content .left-panel__header {
    font-weight: bold;
    padding: 0 16px;
    height: 39px;

    border-top: 1px solid transparent;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
    display: flex;
    box-sizing: border-box;
    align-items: center;
}

.left-panel .left-panel__content .left-panel__content-body {
    padding: 16px 15px;
    height: calc(100% - 40px - 30px);
}

.right-panel {
    width: 288px;
    float: right;
    height: inherit;
    background: #fff;
    border: 1px solid #e7e7e7;

    .form-mask {
        position: absolute;
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0px;
        cursor: not-allowed;
        z-index: 1000;
    }
}

.right-panel .right-panel__content .right-panel__content-body {
    position: relative;
    // border: 1px red solid;
    padding: 16px;
    overflow-x: hidden;
    overflow-y: auto;
    height: 90vh;

    ::v-deep .el-input__count {
        background: none;
    }
}

::v-deep .right-panel .right-panel__content .el-form-item__label {
    line-height: 1.5;
    margin-bottom: 0px !important;
}

::v-deep .right-panel .right-panel__content .el-form-item {
    margin-bottom: 16px;
}

.right-panel .right-panel__content .right-panel__header {
    font-weight: bold;
    padding: 0 16px;
    height: 39px;
    display: flex;
    align-items: center;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e7e7e7;
    box-sizing: border-box;
}

.video-bar {
    color: #fff;
    width: inherit;
    height: 74px;
    overflow: hidden;
    background: #03053d;

    ::v-deep .el-slider__runway,
    ::v-deep .el-slider__bar {
        height: 4px;
    }

    ::v-deep .el-slider__button {
        width: 10px;
        height: 10px;
    }

    ::v-deep .el-input-number {
        .el-input__inner {
            background: rgba(255, 255, 255, 0.3);
            color: #fff;
            border-color: rgba(255, 255, 255, 0.4);
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            background: rgba(255, 255, 255, 0.3);
            color: #fff;
            border-color: rgba(255, 255, 255, 0.4);
            border-left-color: transparent;
        }
    }
}

.video-bar__content {
    padding: 0px 16px;

    .total-duration {
        padding: 0 4px;
    }

    .border-right {
        border-right: 2px solid rgba(255, 255, 255, 0.5);
    }
}

.bottom-panel {
    background: #fff;
    border-top: 1px solid #e7e7e7;
    display: block;
    width: inherit;
    overflow: hidden;
}

.bottom-panel .bottom-panel__header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #e7e7e7;
}

.bottom-panel .bottom-panel__header-title {
    padding: 0 16px;
    font-weight: bold;
}

.bottom-panel .bottom-panel__content {
    &-main {
        height: 160px;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        position: relative;
        --swiper-navigation-size: 30px;
        /* 设置按钮大小 */
    }
}

.mySwiper {
    flex: 1;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    align-items: center;
}

.swiper-1 .swiper-slide {
    width: calc(1 / 8 * 100% - 8px);

    @media only screen and (min-width: 1200px) {
        width: calc(1 / 4 * 100% - 8px);
    }

    @media only screen and (min-width: 1440px) {
        width: calc(1 / 6 * 100% - 8px);
    }

    @media only screen and (min-width: 1600px) {
        width: calc(1 / 7 * 100% - 8px);
    }

    @media only screen and (min-width: 1920px) {
        width: calc(1 / 8 * 100% - 8px);
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
    }

    .category-card {
        width: 100%;
    }
}

.button-prev-wrap {
    position: relative;
    width: 68px;
    height: inherit;
}

.button-next-wrap {
    position: relative;
    width: 68px;
    height: inherit;
}

.swiper-button-next {
    right: 50%;
    transform: translateX(50%);
    /* width: 30px;
  height: 30px;
  background: #ededf1 !important;
  border-radius: 50%;
  color: #fff; */
}

.swiper-button-prev {
    left: 50%;
    transform: translateX(-50%);
    /* width: 30px;
  height: 30px;
  background: #ededf1 !important;
  border-radius: 50%;
  color: #fff; */
}

.is-video {
    .annotator-middle-panel {
        height: calc(100% - 40px - 50px - 160px - 74px);
    }

    .bottom-panel .bottom-panel__header-title {
        cursor: pointer;
    }

    .bottom-tab-active {
        position: relative;
        color: #2e7df8;

        &::after {
            content: '';
            position: absolute;
            width: calc(100% - 32px);
            height: 2px;
            bottom: -15px;
            left: 16px;
            background: #2e7df8;
        }
    }
}
</style>
<style lang="scss">
.c-confirm-dialog {
    background: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .el-message-box__title {
        color: #303133;
    }

    .el-message-box__content {
        color: #606266;
    }

    .el-message-box__btns {
        .el-button {
            border: 1px solid #dcdfe6 !important;
            color: #606266 !important;
            background: #fff !important;
        }

        .el-button--primary {
            background-color: #409eff !important;
            border-color: #409eff !important;
            color: #fff !important;
        }
    }
}

.c-date-popper {
    transform: translateX(-20px);
}

.el-tooltip__popper.is-light {
    border: 0 !important;
}
</style>
